import { useEffect, useState } from 'react';

const IntercomChat = () => {
  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [jwtToken, setJwtToken] = useState(() => sessionStorage.getItem('intercomJwt') || null);
  const [isVerified, setIsVerified] = useState(!!jwtToken);

  // Винесено окремо, щоб уникати дублювань
  const bootIntercom = (token, email = '') => {
    if (!window.Intercom) return;

    window.Intercom('shutdown'); // обов'язково скидаємо перед boot
    window.Intercom('boot', {
      app_id: 'yx1sd1bf',
      intercom_user_jwt: token,
      email,
      confirmed: true,
      hide_default_launcher: false
    });

    window.Intercom('show');
  };

  // 1. Завантаження Intercom скрипта
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://widget.intercom.io/widget/yx1sd1bf';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      const token = sessionStorage.getItem('intercomJwt');
      const storedEmail = sessionStorage.getItem('intercomEmail');
      if (token) {
        bootIntercom(token, storedEmail);
        setJwtToken(token);
        setIsVerified(true);
      }
    };

    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, []);

  // 2. Якщо є токен у URL — перевірити його
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenParam = urlParams.get('token');
    if (!tokenParam) return;

    const verifyToken = async () => {
      try {
        const res = await fetch(`/api/intercom/verify-token?token=${tokenParam}`);
        const data = await res.json();
        if (data.token) {
          const storedEmail = sessionStorage.getItem('intercomEmail');
          sessionStorage.setItem('intercomJwt', data.token);
          setJwtToken(data.token);
          setIsVerified(true);
          setEmailSent(true);
          setShowModal(true);
          bootIntercom(data.token, storedEmail);
          window.history.replaceState({}, document.title, window.location.pathname); // очистити URL
        }
      } catch (err) {
        console.error('❌ Token verification failed');
      }
    };

    verifyToken();
  }, []);

  // 3. Закриття модалки після підтвердження
  useEffect(() => {
    if (emailSent && isVerified) {
      const timer = setTimeout(() => setShowModal(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [emailSent, isVerified]);
  useEffect(() => {
    window.openIntercomChat = () => setShowModal(true);
    return () => {
      delete window.openIntercomChat;
    };
  }, []);
  // 4. Відправка листа з підтвердженням
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      sessionStorage.setItem('intercomEmail', email);
      await fetch('/api/intercom/send-confirmation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      setEmailSent(true);
    } catch (err) {
      console.error('❌ Failed to send email');
    }
  };

  return (
    <>
      {!isVerified && (
        <button className='bubble' onClick={() => setShowModal(true)} style={styles.bubble}>💬</button>
      )}

      {showModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            {emailSent && isVerified ? (
              <p style={styles.waiting}>✅ Email confirmed! Chat is now available.</p>
            ) : emailSent ? (
              <p style={styles.waiting}>📨 Check your email and click the confirmation link.</p>
            ) : (
              <>
                <h3>Enter your email to start chat</h3>
                <form onSubmit={handleSubmit}>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="you@example.com"
                    style={styles.input}
                  />
                  <div style={styles.actions}>
                    <button type="submit" className='basic-button '>Submit</button>
                    <button type="button" className='basic-button transparent-button' onClick={() => setShowModal(false)}>Cancel</button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  bubble: {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    backgroundColor: '#F9B135',
    color: '#fff',
    border: 'none',
    borderRadius: '50%',
    width: '56px',
    height: '56px',
    fontSize: '24px',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    zIndex: 1000,
  },
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1001,
  },
  modal: {
    background: 'radial-gradient(100.15% 191.04% at 15.32% 0%, #171717 0%, #101010 66.17%)',
    padding: '24px',
    borderRadius: '10px',
    width: '90%',
    maxWidth: '400px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
    color: '#fff',
  },
  input: {
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    marginBottom: '16px',
    borderRadius: '6px',
    border: '1px solid #ccc',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  button: {
    padding: '10px 16px',
    fontSize: '14px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: '#2e62f1',
    color: '#fff',
  },
  waiting: {
    marginTop: '12px',
    fontStyle: 'italic',
    color: '#aaa',
  },
  
};

export default IntercomChat;
